<template lang="pug">
  .social-footer
    ul
      li
        a(
          target="_blank",
          itemprop="sameAs",
          rel="noopener nofollow",
          :href="CONTACTS.twitter")
          BrandsTwitterIcon.svg-icon.twitter-icon
      li
        a(
          target="_blank",
          itemprop="sameAs",
          rel="noopener nofollow",
          :href="CONTACTS.facebook")
          BrandsFacebookFIcon.svg-icon.facebook-f-icon
      li
        a(
          target="_blank",
          itemprop="sameAs",
          rel="noopener nofollow",
          :href="CONTACTS.instagram")
          BrandsInstagramIcon.svg-icon.instagram-icon
      li
        a(
          target="_blank",
          itemprop="sameAs",
          rel="noopener nofollow",
          :href="CONTACTS.linkedin")
          BrandsLinkedinInIcon.svg-icon.linkedin-in-icon
      li
        a(
          target="_blank",
          itemprop="sameAs",
          rel="noopener nofollow",
          :href="rssLink")
          SolidRssIcon.svg-icon.rss-icon
</template>

<script>
import CONFIG from 'Config';
import { CONTACTS } from 'Config/constans';
import SolidRssIcon from 'images/svg-icons/solid-rss.svg';
import BrandsTwitterIcon from 'images/svg-icons/brands-twitter.svg';
import BrandsFacebookFIcon from 'images/svg-icons/brands-facebook-f.svg';
import BrandsInstagramIcon from 'images/svg-icons/brands-instagram.svg';
import BrandsLinkedinInIcon from 'images/svg-icons/brands-linkedin-in.svg';

export default {
  name: 'TheFooterSocialLinks',
  components: {
    SolidRssIcon,
    BrandsTwitterIcon,
    BrandsFacebookFIcon,
    BrandsInstagramIcon,
    BrandsLinkedinInIcon,
  },
  staticData: {
    rssLink: CONFIG.urls.rssLink,
    CONTACTS,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.social-footer
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: flex-start
  margin-top: 45px
  @media screen and (max-width: 767px)
    margin-top: 50px
  ul
    display: flex
    list-style-type: none
    @media screen and (max-width: 1024px)
      margin-bottom: 0
    @media screen and (max-width: 991px)
      margin-bottom: 0
    li
      padding-bottom: 0
      padding-right: 20px
      @media screen and (max-width: 767px)
        padding-right: 48px
        line-height: 20px
      &:last-child
        padding-right: 0
      a
        color: $white!important
        fill: $white!important
        +mt(.3s)
        &:hover
          +mt(.3s)
          opacity: 0.8
</style>
